module.exports = __webpack_public_path__ + "media/images/faq-title-f5b04bb1965b37357419a8c5af2296c3.png";